/**
 * Question post-événement (section 4.8) : « cette rencontre a-t-elle mené à
 * quelque chose de concret ? ». Quatre choix, un geste chacun.
 *
 * La note sous les choix n'est pas décorative : dire au participant que sa
 * réponse ne note personne et n'est vue ni par l'autre ni par l'organisateur
 * conditionne l'honnêteté des réponses — et le moteur apprend de ces réponses.
 */
import { useEffect, useState } from 'react';
import { appelerApi, envoyer } from '../reseau.ts';
import { nomAffiche } from './FicheParticipant.tsx';

type Question = {
  connexion_id: string;
  origine: string;
  fiche: { prenom: string | null; nom: string | null; entreprise: string | null; fonction: string | null } | null;
};

const CHOIX = [
  { valeur: 'aucune_suite', texte: 'Pas de suite' },
  { valeur: 'discussion_en_cours', texte: 'Discussion en cours' },
  { valeur: 'partenariat_ou_contrat', texte: 'Partenariat ou contrat' },
  { valeur: 'autre', texte: 'Autre' },
] as const;

export function Concretisation() {
  const [questions, setQuestions] = useState<Question[]>([]);

  useEffect(() => {
    void appelerApi<{ questions: Question[] }>('/api/concretisation/a-repondre').then((r) => {
      if (r.donnees) setQuestions(r.donnees.questions);
    });
  }, []);

  const repondre = async (q: Question, resultat: string) => {
    setQuestions((liste) => liste.filter((x) => x.connexion_id !== q.connexion_id));
    await envoyer(`/api/concretisation/${q.connexion_id}/repondre`, { resultat });
  };

  if (questions.length === 0) return null;

  return (
    <section className="carte concretisation" aria-labelledby="titre-concretisation">
      <h2 id="titre-concretisation">Vos rencontres ont-elles abouti ?</h2>
      <p className="concretisation__note">
        Votre réponse porte sur la mise en relation, jamais sur la personne. Elle n'est visible ni
        par elle, ni par l'organisateur.
      </p>
      <ul className="concretisation__liste">
        {questions.slice(0, 3).map((q) => (
          <li key={q.connexion_id} className="concretisation__question">
            <p className="concretisation__personne">
              Votre rencontre avec{' '}
              <strong>{q.fiche ? nomAffiche({ ...q.fiche }) : 'un participant'}</strong>
              {q.fiche?.entreprise ? ` (${q.fiche.entreprise})` : ''}
            </p>
            <div className="concretisation__choix">
              {CHOIX.map((c) => (
                <button
                  key={c.valeur}
                  className="puce cible"
                  onClick={() => void repondre(q, c.valeur)}
                >
                  {c.texte}
                </button>
              ))}
            </div>
          </li>
        ))}
      </ul>
      {questions.length > 3 && (
        <p className="concretisation__reste">Encore {questions.length - 3} rencontre(s) à évaluer.</p>
      )}
    </section>
  );
}
